var _rect, _line, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 23,
    viewBox: "0 0 35 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.603906,
    y: 1.475,
    width: 33.3297,
    height: 20.049,
    rx: 4.48023,
    stroke: "#0A0B0C",
    strokeWidth: 1.2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.19238,
    y1: 7.39785,
    x2: 33.3407,
    y2: 7.39785,
    stroke: "#0A0B0C",
    strokeWidth: 1.11837
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.76562 16.8125H13.1004",
    stroke: "#0A0B0C",
    strokeWidth: 1.11837,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/payment-icon.c274f74c0e3f24cbcf66621b29bdd262.svg";
export { ForwardRef as ReactComponent };